export enum ReadMoreType {
    NONE = "none",
    INCREASE_HEIGHT = "increaseHeight",
    SHOW_IN_DIALOG = "showInDialog"
}